import { render, staticRenderFns } from "./part-add-or-update.vue?vue&type=template&id=21f9d4b6&scoped=true"
import script from "./part-add-or-update.vue?vue&type=script&lang=js"
export * from "./part-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./part-add-or-update.vue?vue&type=style&index=0&id=21f9d4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f9d4b6",
  null
  
)

export default component.exports